import React, { useState, useEffect } from 'react';
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import { useStateValue } from "./StateProvider";
import db from "./firebase";
import './Goals.css';
import { actionTypes } from './Reducer';
import shortId from "shortid";

function Goals() {
    const [{ classes }] = useStateValue();
    const [newGoal, setNewGoal] = useState("");
    const [{ goals, user }, dispatch] = useStateValue();
    
    var goalsRef = db
    .collection("users")
    .doc(user?.uid)
    .collection("goals")
    .doc("goalItems");
    
    useEffect(() => {
        // Project just restarted
        db.collection('users')
        .doc(user?.uid)
        .collection("goals")
        .get()
        .then((querrySnapshot) => {
            querrySnapshot.forEach((doc) => {
                // Push goals to data layer
                dispatch({
                    type: actionTypes.UPDATE_GOALS,
                    goals: doc.data().goals
                })
            })
        })
    }, [])

    useEffect(() => {
        if (goals !== undefined) {
            for (var i = 0; i < goals.length; i++) {
                if (goals[i].clicked === true) {
                    var tempGoals = goals;
                    var goalIndex = tempGoals.findIndex((item) => item.id === goals[i].id);
                    tempGoals.splice(goalIndex, 1);

                    dispatch({
                        type: actionTypes.UPDATE_GOALS,
                        goals: tempGoals,
                    })

                    goalsRef.set({
                        goals: tempGoals,
                    });
                }
            }
        }
    }, [goals])

    const addGoal = (e) => {
        e.preventDefault();
        if (newGoal !== "" && goals?.length < 8) {
            var tempGoals;
            goals !== undefined ? (tempGoals = goals) : (tempGoals = []);

            tempGoals.push({goal: newGoal, clicked: false, id: shortId.generate()});

            // Handle adding newGoal
            goalsRef.set({
                goals: tempGoals,
            });

            dispatch({
                type: actionTypes.UPDATE_GOALS,
                goals: tempGoals
            })
        }

        setNewGoal("");
    };

    const toggleCheckbox = (goal) => {
        var tempGoals;
        goals !== undefined ? (tempGoals = goals) : (tempGoals = []);
        var goalIndex = tempGoals.findIndex((item) => item.id === goal.id);
        tempGoals[goalIndex].clicked = !tempGoals[goalIndex].clicked
        
        // Update data layer
        dispatch({
            type: actionTypes.UPDATE_GOALS,
            goals: tempGoals
        })
        // Update db
        goalsRef.set({
            goals: tempGoals,
        })
    }
    
    return (
        <div className="goals" style={classes.length === 0 ? ({display: "none"}) : null}>
            <div className="goals__container">
                <h1>Goals:</h1>
                <div className="goals__goalItems">
                    {goals?.map((item, i) => (
                        <div className="goals__goal" key={i}>
                            <input
                                type="checkbox"
                                checked={item.clicked}
                                onChange={(e) => {
                                    e.preventDefault();
                                    toggleCheckbox(item);
                                }}
                            />
                            <h3>{item.goal}</h3>
                        </div>
                    ))}
                </div>
                <div className="goals__lowerContainer">
                    <div className="goals__addItem">
                        <form>
                            <IconButton
                            className="goals__addBtn"
                            type="submit"
                            onClick={addGoal}
                            >
                                <AddIcon />
                            </IconButton>
                            <input
                            type="text"
                            placeholder="Add goal"
                            value={newGoal}
                            maxLength="100"
                            onChange={(e) => {
                                setNewGoal(e.target.value);
                            }}
                            />
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Goals
